import { Answers, initialAnswers } from './answers';
import { CustomerIdentification, initialAstoriaCustomerIdentification } from './customer-identification';
import { DefectServicePartIdentification } from './defect-service-part-identification';
import { FunctionalElements, initialFunctionalElements } from './functional-elements';
import { initialRadioOptions, RadioOptions } from './radio-options';
import { RemarksSection } from './remarks-section';

export type EditableFormElements = Readonly<{
    answers: Answers;
    options: RadioOptions;
    customerIdentification: CustomerIdentification;
    defectServicePartIdentification?: DefectServicePartIdentification; // only for service part questionnaires
    remarksSection?: RemarksSection;
    functionalElements: FunctionalElements;
    xml: string;
}>;

export const initialEditableFormElementsState: EditableFormElements = {
    answers: initialAnswers,
    customerIdentification: initialAstoriaCustomerIdentification,
    functionalElements: initialFunctionalElements,
    options: initialRadioOptions,
    xml: '',
    remarksSection: undefined,
    defectServicePartIdentification: undefined, // only for service part questionnaires
};
